<template>
  <section>
    <div class="content-devx padding-half">
      <div class="card-header-title margin-left-half margin-bottom">
        {{ $t("treatment.treatmentPlan.treatmentCreatePlan.observations") }}
      </div>
      <f7-block>
        <f7-row>
          <f7-col>
            <div class="dx-field">
              <div>
                <DxTextArea
                  :value="getObservations"
                  @value-changed="onChangeDescription"
                />
              </div>
            </div>
          </f7-col>
        </f7-row>
      </f7-block>
    </div>
  </section>
</template>

<script>
import { DxTextArea } from "devextreme-vue/text-area";
import { mapActions, mapState } from "vuex";

export default {
  name: "TreatmentObservations",
  components: {
    DxTextArea,
  },
  computed: {
    ...mapState("treatmentStepper", ["treatmentPlan"]),
    getObservations() {
      return this.treatmentPlan.observation ?? "";
    },
  },
  methods: {
    ...mapActions("treatmentStepper", ["setObservation"]),
    onChangeDescription(e) {
      this.setObservation(e.value ?? "");
    },
  },
};
</script>